<template>
  <div class="container">
    <Tbheader
      :tipo="tipo + ' - Serviços: ' + segmento.titulo"
      :novo="novo"
      :titulo="contentEdit.titulo"
      :icone="icone"
    />
    <form class id="feedback-form" @submit="formSubmit" method="post">
      <div class="row">
        <div class="col-2 form-group">
          <label>Vincular com serviço?</label>
          <select
            v-model="contentEdit.servicoId"
            name="servicoId"
            id="servicoId"
            class="form-control required valid"
            value
          >
            <option value="">Não</option>
            <option
              :key="item.servicoId"
              v-for="item in servicosLista"
              :value="item.servicoId"
            >
            {{item.titulo}}
            </option>
          </select>
        </div>
        <div class="col-6 form-group">
          <label>Título:</label>
          <input
            type="text"
            v-model="contentEdit.titulo"
            name="titulo"
            id="titulo"
            class="form-control required valid"
            value
          />
        </div>

          <div class="col-md-2 form-group">
          <label>Ativo:</label>
          <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="ativo"
              :class="{'active': contentEdit.ativo == true}"
            >
              <input type="radio" name="ativo" id="ativo" @change="fnAtiva() " :value="true" autocomplete="off" class="valid" /> Sim
            </label>
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="inativo"
              :class="{'active': contentEdit.ativo == false}"
            >
              <input type="radio" name="ativo" id="inativo"  @change="fnAtiva()"  :value="false" autocomplete="off" class="valid" /> Não
            </label>
          </div>
      </div>
      <div class="col-md-2 form-group">
          <label>Destaque:</label>
          <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="destaqueativo"
              :class="{'active': contentEdit.destaque == true}"
            >
              <input type="radio" name="destaqueativo" id="destaqueativo" @change="fnDestaque() " :value="true" autocomplete="off" class="valid" /> Sim
            </label>
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="destaqueinativo"
              :class="{'active': contentEdit.destaque == false}"
            >
              <input type="radio" name="destaqueativo" id="destaqueinativo"  @change="fnDestaque()"  :value="false" autocomplete="off" class="valid" /> Não
            </label>
          </div>
      </div>
      <div class="col-sm-12 form-group"  v-if="contentEdit.destaque">
          <label>Intro Home:</label>
          <textarea
            v-model="contentEdit.resumoHome"
            name="resumoHome"
            id="resumoHome"
            class="form-control required valid"
            value
          ></textarea>
      </div>
       <div class="col-sm-12">
            <label>Texto</label>
          <vue-editor class="vEditor" :editor-toolbar="customToolbar" v-model="contentEdit.texto" />
        </div>
        <div class="col-12 form-group"></div>
        
        <div class="col-6 ml-auto text-right">
          <button
            type="button"
            name="cancelar"
            class="btn btn-danger btn-md"
            @click="fnCancela()"
          >
            Cancelar
          </button>
          <button
            type="submit"
            name="feedback-form-submit"
            class="btn btn-success ml-3"
          >
            Gravar
          </button>
        </div>
      </div>
      <div style="display: none;">{{carregadoImg}}</div>
    </form>
  </div>
</template>

<script>
import Tbheader from "../_headerTabelas";
import { getData, getSuccess, getError, urlApi } from "../../global/utils";
import { VueEditor } from "vue2-editor";
export default {
  props: ["id"],
  data() {
    return {
      novo: true,
      tipo: "",
      icone: "",
      urlApi: urlApi,
      suporteAtivo: true,
      success: false,
      carregadoIm: false,
      error: null,      
      contentFotos: [],
      carregado: true,
      files: [],
      imagem: [],
      segmento: [],
      servicosLista: [],
      logotipoRodape: [],
      contentEdit: {
        titulo: "",
        segmentoId: parseInt(this.$route.params.id),
        servicoid: null,
        ativo: true,
      },
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
    };
  },
  components: { Tbheader,VueEditor},
  methods: {
    OnFileSelected(event) {
      if (event.target.id == "imagem") {
        this.contentEdit.imagem = URL.createObjectURL(
          event.target.files[0]
        );
        this.imagem = event.target.files[0];
        this.carregado = true;
        this.carregadoIm = true;
      } 
    },
    fnDestaque() {
      this.contentEdit.destaque = !this.contentEdit.destaque;
    },
    fnRemoveFoto(tipo, i) {
      var filename = "";
      if (i == 1) {
        filename = this.contentEdit.imagem
          .split("/")
          .pop()
          .split("#")[0]
          .split("?")[0];
        this.contentEdit.imagem = null;
      } 
      this.$http
        .delete(
          "esinistros/upload/esinistros/servicos/" +
            filename +
            "/arquivo"
        )
        .then((res) => {
          console.log(res);
        });
    },
    GetFilename(url) {
      if (url) {
        var m = url.toString().match(/.*\/(.+?)\./);
        if (m && m.length > 1) {
          return m[1];
        }
      }
      return "";
    },
    OnUpload() {
      let fd = new FormData();
      if (this.imagem.name != undefined) {
        fd.append("files", this.imagem, this.imagem.name);
      }
     
      this.$http
        .post("esinistros/upload/esinistros/servicos", fd)
        .then(() => {
          this.carregado = true;
        });
    },
    fnLimpa() {
      this.contentEdit.titulo = "";
      this.contentEdit.ativo = "";
    },
    fnicone() {
      this.icone = this.novo ? "icon-line2-plus" : "icon-line-edit";
    },
    fnAtiva() {
      this.contentEdit.ativo = !this.contentEdit.ativo;
    },
    fnCancela() {
      this.$router.push({ path: `/esinistros/servicos/${this.$route.params.id}` });
    },
    async formSubmit(e) {
      e.preventDefault();
       let metodo = null
       let completaUrl = null
       console.log(this.$route.params.idServico)
        metodo = this.$route.params.idServico ? "put" : "post";
       completaUrl = this.$route.params.idServico
        ? "/" + this.$route.params.idServico
        : "";
      if (this.contentEdit.servicoId == ''){
        this.contentEdit.servicoId = null;
      }
       console.log(metodo)

      let data = await this.$http[metodo](
        "/esinistros/servicos" + completaUrl,
        this.contentEdit
      )
        .then(() => {

          getSuccess();
          this.fnLimpa();
          this.fnCancela();
        })
        .catch((e) => {
          return e;
        });
      this.error = data;
    },
    fnGetError(e) {
      getError(e);
    },
    fnIsEdit() {
      console.log(this.$route.params.idServico);
      if (this.$route.params.idServico != undefined && this.$route.params.idServico != "") {
        if(this.$route.meta.breadcrumb == "Copiar"){
        this.tipo = "Copiando";
        this.novo = true;
        this.fnCarregaItems(this.$route.params.idServico);

        }else{
        this.tipo = "Editando";
        this.novo = false;
        this.fnCarregaItems(this.$route.params.idServico);

        }
      } else {
        this.tipo = "Incluindo";
        this.novo = true;
        this.contentEdit.ativo = false;
      }
      this.fnicone();
    },
    formatData(value) {
      return this.$moment(String(value)).format("DD/MM/YYYY HH:MM");
    },
    async fnCarregaItems(valueId) {
      let data = await getData(this.urlApi + "esinistros/servicos/" + valueId);
      this.contentEdit = data[0].content;
      this.$vs.loading.close();

    },

    async fnCarregaServicos() {
      let data = await getData(this.urlApi + "servicos");
      this.servicosLista = data[0].content;

    },
    async fnCarregaSegmento() {
      let data = await getData("esinistros/segmentos/" + this.$route.params.id);
      this.segmento = data[0].content;
      this.$vs.loading.close();
    },
  },
  created() {
    this.fnIsEdit();
    this.fnCarregaSegmento();
    this.fnCarregaServicos();

  },
  computed: {
    confere: function () {
      return this.fnIsEdit();
    },
    temErro() {
      if (this.error) {
        return this.fnGetError(this.error);
      } else {
        return "";
      }
    },
    carregadoImg() {
      if (this.carregadoIm) {
        return this.contentEdit;
      } else {
        return "";
      }
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
#editor1,
#editor2,
#editor3 {
  min-height: 50vh;
}
</style>